import { BaseLink, type BaseLinkProps } from './HeaderRedesignBaseLink';
import { NavContent, NavStyle } from './shared.style';
import styled from 'styled-components';

export const NavBaseLink = styled(BaseLink)`
  /*aligns links and buttons*/
  margin-right: 0.2rem;
  &:link {
    text-decoration: none;
  }
  color: ${(p) => p.theme.midwestColors.black};

  &.active {
    color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
  }

  ${NavStyle}
`;

type Props = BaseLinkProps & {
  text: string;
};

export const NavLink = ({ href, text }: Props) => {
  return (
    <NavBaseLink href={href}>
      <NavContent>{text}</NavContent>
    </NavBaseLink>
  );
};
